export default {
	loadVideo: (videoElSelector, videoSrc, forceStreaming = false) => {
		const $videoEl = $(videoElSelector);
		const loadStart = new Date();
		if (forceStreaming) {
			$videoEl.attr("src", videoSrc);
		} else {
			$videoEl.addClass("hide");
			let r = new XMLHttpRequest();
			r.onload = function () {
				const timeToLoad = (new Date().getTime() - loadStart.getTime()) / 1000;
				console.log("Video load time: ", timeToLoad);
				const blob = (window.webkitURL || window.URL).createObjectURL(
					r.response,
				);
				$videoEl.removeClass("hide");
				// @ts-expect-error
				videojs(videoElSelector).ready(function () {
					// @ts-expect-error
					videojs(videoElSelector).src({
						type: "video/mp4",
						src: blob,
					});
				});
				$videoEl.data("setup", "{}");
				pp.videos.provideStreamingFallback(
					".FallbackTrigger",
					"#FallbackVideo",
					videoSrc,
				);
			};
			r.open("GET", videoSrc);
			r.responseType = "blob";
			r.send();
		}
	},
	provideStreamingFallback: (
		fallbackTriggerSelector,
		fallbackVideoElSelector,
		videoSrc,
	) => {
		// @ts-expect-error
		window.clearTimeout(fallbackTimeout);
		$(fallbackTriggerSelector).on("click", function (e) {
			e.preventDefault();
			$(".video-js").remove();
			$(fallbackVideoElSelector).removeClass("hide");
			pp.videos.loadVideo(fallbackVideoElSelector, videoSrc, true);
			return false;
		});
		let fallbackTimeout = setTimeout(function () {
			$(fallbackTriggerSelector).removeClass("hide");
		}, 10000);
	},
};
